<div class="carded digital-currency">
    <mat-accordion>
        <mat-expansion-panel #expansionPanelElement [expanded]="true" disabled="true">
            <mat-expansion-panel-header collapsedHeight="60px" expandedHeight="60px">
                <mat-panel-title>
                    {{'REQUEST.ELECTRONIC_MONEY_PAYMENT'| translate }}
                </mat-panel-title>
                <button class="request-list-btn" mat-stroked-button [routerLink]="['/withdrawal/electronic-money/list']">{{'REQUEST.REQUESTS' | translate}}
                    <i class="icon-arrow-right"></i>
                </button>
            </mat-expansion-panel-header>
            <div class="body">
                <tc-table-loading *ngIf="servicesIsLoading"></tc-table-loading>
                <div *ngFor="let item of services" class="service-container" [ngClass]="{'show-sub-service': item.showSub}">
                    <div class="main-service" (click)="clickService(item)">
                        <div class="img">
                            <img [src]="item.serviceIcon">
                        </div>
                        <div class="title">
                            <span>{{item.serviceName}}</span>
                        </div>
                    </div>
                    <div *ngIf="item.childrenServices" class="sub-service">
                        <div class="head">
                            <span>{{item.serviceName}}</span>
                        </div>
                        <i class="icon-cancel icon" (click)="hideSubService(item)"></i>
                        <ng-container *ngIf="item.hasSubService">
                            <div class="type">
                                <mat-radio-group [(ngModel)]="selectedService">
                                    <mat-radio-button class="radio-button-new" *ngFor="let subService of item.childrenServices" [value]="subService">
                                        {{subService.serviceName}}
                                    </mat-radio-button>
                                </mat-radio-group>

                            </div>
                            <div class="next-button">
                                <button mat-flat-button [ngClass]="{'deactive': !selectedService}" (click)="selectService()">{{'GENERAL.NEXT'| translate}}</button>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

        </mat-expansion-panel>
    </mat-accordion>
</div>